import styles from './Container.module.scss'

import React from 'react'
import classnames, { Value } from 'classnames'

interface Props {
    className?: Value
}

const Container: React.FC<Props> = ({ className, children }) => {
    return <div className={classnames(styles.container, className)}>{children}</div>
}

export default Container
